import type { components } from '@pba/types-openapi-node';

export type NodeCommunity = {
  id: string;
  membersCount: number;
  name: string;
};

export const createNodeCommunity = (data: components['schemas']['Community']): NodeCommunity => ({
  id: data._id,
  membersCount: data.membersCount ?? 0,
  name: data.name,
});
